import Com from "components/styledComp/CommStyledComp";
import React from "react";

const SaaSSecurity = () => {
  return (
    <Com.DivDetailSection>
      <Com.DivDetailHeading>
        <Com.DetailHeading>보안·신뢰성</Com.DetailHeading>
      </Com.DivDetailHeading>
      <div className="strategy-list">
        <div className="strategy">
          <Com.SpanStrategy>1</Com.SpanStrategy>
          <div className="strategy-title">
            <Com.StrongStrategy>데이터·접근 보안</Com.StrongStrategy>
            <p className="strategy-desc">
              테넌트·사용자 단위 권한 분리<br />
              인증·인가 체계 및 통신 구간 보호 적용
            </p>
          </div>
        </div>
        <div className="strategy">
          <Com.SpanStrategy>2</Com.SpanStrategy>
          <div className="strategy-title">
            <Com.StrongStrategy>가용성·복구</Com.StrongStrategy>
            <p className="strategy-desc">
              장애 상황에서도 안정적인 서비스 유지<br />
              백업·복구·감시 체계 운영 프로세스 포함
            </p>
          </div>
        </div>
        <div className="strategy">
          <Com.SpanStrategy>3</Com.SpanStrategy>
          <div className="strategy-title">
            <Com.StrongStrategy>보안 업데이트</Com.StrongStrategy>
            <p className="strategy-desc">
              보안 패치와 개선 사항을 클라우드에서<br />
              신속하고 일관되게 반영
            </p>
          </div>
        </div>
      </div>
    </Com.DivDetailSection>
  );
};

export default SaaSSecurity;
